
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12768',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12768",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.484",
  "data-fetching-client": "static-1.9791",
  "foundations-components": "static-1.8191",
  "foundations-components-legacy": "static-1.1216",
  "foundations-theming": "static-1.4562",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.83",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8150",
  "hub-http-shared-msw-handlers": "static-1.10286",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11600",
  "I18n": "static-7.1641",
  "jasmine-runner": "static-1.6587",
  "marketplace-storefront-base": "static-1.12831",
  "quartz": "static-1.7202",
  "react-dlb": "static-1.81",
  "react-rhumb": "static-1.16814",
  "reactive-variable-buffer-atom": "static-1.2987",
  "reporting-testing-lib": "static-1.10016",
  "settings-ui-lib": "static-1.12652",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7374",
  "ui-addon-i18n": "static-1.11279",
  "ui-addon-react-router-dom": "static-1.9666",
  "unified-auth": "static-1.649",
  "unified-auth-core-lib": "static-1.931",
  "usage-tracker": "static-1.7481",
  "usage-tracker-core": "static-1.7331",
  "customer-data-property-utils": "static-1.8225",
  "hub-http": "static-1.6352",
  "integrations-lib": "static-1.16565",
  "marketplace-ui-common": "static-1.20197",
  "property-management-iframe": "static-1.13596",
  "quartz-config": "static-1.980",
  "quartz-core": "static-1.6421",
  "quartz-routing": "static-1.632",
  "quick-fetch": "static-1.4015",
  "react": "static-7.187",
  "rpc-client-utils": "static-1.4787",
  "ts-schema": "static-1.4179",
  "ui-universal-auth": "static-1.9135",
  "UIComponents": "static-3.8546",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3497",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3479",
  "quartz-webpack": "static-1.3426",
  "bend-plugin-quartz-routing": "static-1.280",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4460",
  "floating-ui": "static-1.58",
  "foundations-assets": "static-1.5004",
  "foundations-theming-specialty": "static-1.2278",
  "framer-motion": "static-1.73",
  "hs-story-utils": "static-1.9553",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.39",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5439",
  "react-virtualized": "static-2.100",
  "StyleGuideUI": "static-3.489",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2215",
  "ui-fonts": "static-1.862",
  "ui-images": "static-2.1188",
  "bend-plugin-foundations-theming": "static-1.3045",
  "foundations-theming-base": "static-1.3547",
  "stylex": "static-1.35",
  "HeadJS": "static-2.773",
  "hs-test-utils-bend-plugin": "static-1.3261",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4455",
  "ai-components-ui-library": "static-1.9280",
  "ai-rendering-library": "static-1.10647",
  "chirp-fetch": "static-1.2018",
  "connections-embed-lib": "static-1.1239",
  "copilot-toolkit": "static-1.11466",
  "feedback-loader": "static-1.29538",
  "laboratory-lib": "static-3.7282",
  "marketplace-embed": "static-1.22492",
  "marketplace-ui-details": "static-1.10092",
  "marketplace-ui-reviews": "static-1.20152",
  "marketplace-ui-tracking": "static-1.14367",
  "sanitize-text": "static-1.8277",
  "ui-addon-video-player": "static-1.8835",
  "usage-tracker-multi": "static-1.5895",
  "usage-tracker-session-replay": "static-1.5167",
  "wootric-nps": "static-1.7080",
  "quartz-head": "static-1.867",
  "web-vitals": "static-1.7",
  "apollo-link-hub-http": "static-2.4781",
  "immer": "static-1.33",
  "immerable": "static-1.4280",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2578",
  "reporting-data": "static-1.68083",
  "cssUtils": "static-1.830",
  "flux-actions": "static-1.348",
  "HubStyle": "static-2.11907",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10337",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10492",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7471",
  "icons": "static-2.656",
  "marketplace-ui-apps-core": "static-1.18729",
  "storybook-react": "static-1.34",
  "trellis-story-utils": "static-1.4640",
  "foundations-components-test-utils": "static-1.5674",
  "quartz-i18n": "static-1.877",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.55",
  "ads-unified-auth-lib": "static-1.460",
  "google-sheets-integration-lib": "static-1.620",
  "microsoft-drive-integration-lib": "static-1.768",
  "surveymonkey-integration-lib": "static-1.76",
  "slack-ui-library": "static-1.10527",
  "fsm": "static-1.3861",
  "customer-data-objects": "static-1.7809",
  "property-translator": "static-1.5527",
  "hs-locale-management": "static-1.178",
  "frontend-preferences-client": "static-1.8056",
  "hs-promise-utils": "static-1.5723",
  "hubspot-apollo-client": "static-1.5008",
  "integrations-error-boundary-lib": "static-1.13980",
  "integrations-tracking-lib": "static-1.5737",
  "native-integrations-shared-strings": "static-1.7911",
  "reselect": "static-2.16",
  "sanitize": "static-1.4607",
  "superstore": "static-1.4890",
  "ui-shepherd-react": "static-3.10383",
  "ai-settings-ui-library": "static-1.8095",
  "hub-http-janus": "static-1.848",
  "hubspotter-http": "static-1.4748",
  "immutable-less": "static-1.4782",
  "marketplace-ui-client-types": "static-1.17604",
  "nav-meta": "static-1.29956",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18171",
  "inbound-db-properties-service-client": "static-1.3943",
  "property-management-common": "static-1.5884",
  "ui-addon-iframeable": "static-1.9197",
  "dispatcher": "static-1.139",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.547",
  "module-federation": "static-1.27",
  "quartz-auth": "static-1.877",
  "quartz-test": "static-1.877",
  "quartz-tracking": "static-1.581",
  "trellis-components": "static-1.2234",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.197",
  "bender-build-tools": "static-1.3301",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21911",
  "ContentUtils": "static-1.68744",
  "customer-data-objects-ui-components": "static-1.13159",
  "sassPrefix": "static-1.158",
  "avatar-components": "static-1.2628",
  "breeze-engine-core": "static-1.443",
  "breeze-onboarding-components": "static-1.288",
  "customer-data-filters-ui": "static-1.40250",
  "customer-data-reference-ui-components": "static-1.13305",
  "embedded-academy-lib": "static-1.14777",
  "ExportDialog": "static-6.10510",
  "highlight.js": "static-1.80",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41628",
  "reporting-snowflake": "static-1.56701",
  "reporting-ui-components": "static-2.65354",
  "reporting-visualizations": "static-1.60159",
  "trellis-theming": "static-1.1073",
  "ui-addon-teams": "static-1.21719",
  "integrations-reconnect-lib": "static-1.212",
  "magpie-lib": "static-1.5640",
  "navigation-components": "static-1.18319",
  "breeze-engine-lib": "static-1.1165",
  "magpie-types": "static-1.5100",
  "simple-logging-lib": "static-1.3179",
  "ai-studio-lib": "static-1.11998",
  "app-governance-lib": "static-1.1963",
  "developer-experience-shared-components": "static-1.10654",
  "hubspot-prosemirror": "static-1.18601",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8139",
  "ui-product-approvals": "static-1.28662",
  "ui-tool-access": "static-1.10280",
  "usage-based-billing-components-lib": "static-1.9484",
  "usage-tracker-anonymous": "static-1.5898",
  "usage-tracker-public": "static-1.7292",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3684",
  "persist-promise": "static-1.3831",
  "reference-resolvers": "static-1.8306",
  "ui-extensibility-client-types": "static-1.4054",
  "hubspot-apollo-cache": "static-1.467",
  "universal-page-editor-lib": "static-1.3141",
  "final-form": "static-1.71",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.3142",
  "atom": "static-1.5206",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6112",
  "salesImages": "static-1.527",
  "batch-promise": "static-1.1674",
  "crm-component-utils": "static-1.39422",
  "crm-properties-common-lib": "static-1.6020",
  "customer-data-properties": "static-1.52004",
  "framework-data-schema-resolvers": "static-1.7024",
  "property-value-citations": "static-1.2618",
  "reference-resolvers-lite": "static-1.8226",
  "ui-business-units-lib": "static-1.9197",
  "navigation-messaging": "static-1.7646",
  "hubspotter-http-shared-msw-handlers": "static-1.10284",
  "base-ui": "static-1.15",
  "react-day-picker": "static-1.4",
  "tanstack-virtual": "static-1.31",
  "cms-field-types": "static-1.4945",
  "content-icons-ui": "static-1.2264",
  "customer-data-ui-utilities": "static-1.9955",
  "conversations-skeleton-state": "static-1.7377",
  "crm-message-bus": "static-1.43328",
  "customer-data-filters-ui-msw-helpers": "static-1.22685",
  "events-data-lib": "static-1.364",
  "FormUrlGenerator": "static-2.4852",
  "framework-builder-read-service-client": "static-1.4102",
  "framework-data-schema-quick-fetch": "static-1.6929",
  "multi-account-reference-resolvers": "static-1.1112",
  "onboarding-tours": "static-1.16849",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14054",
  "academy-common-lib": "static-1.14237",
  "content-assistance-lib": "static-1.7961",
  "dashboard-lib": "static-1.82032",
  "file-manager-components": "static-1.23985",
  "getting-started-shared-tasks": "static-1.18775",
  "hubspot-prosemirror-plugins": "static-1.18593",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20056",
  "share-with-third-party-component-lib": "static-1.8833",
  "ui-addon-draggable": "static-3.4890",
  "ui-asset-management-lib": "static-1.11203",
  "user-context": "static-1.5238",
  "growth-payments-core": "static-1.25760",
  "reporting-plugins": "static-1.10524",
  "reporting-reports": "static-1.67761",
  "idb-keyval": "static-1.45",
  "reactive-lib": "static-1.856",
  "nest": "static-1.362",
  "ably": "static-2.2",
  "codemirror": "static-5.96",
  "react-codemirror": "static-1.10758",
  "framework-listing-lib": "static-2.29057",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31011",
  "apps-service-types": "static-1.3931",
  "oauth-service-types": "static-1.4384",
  "content-media-capture": "static-1.4914",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8559",
  "payment-link-components": "static-1.23849",
  "ui-addon-emoji-picker": "static-1.10016",
  "video-components-external": "static-1.11704",
  "video-data-lib": "static-1.35362",
  "react-dnd-compat": "static-1.4744",
  "ui-product-approvals-common": "static-1.557",
  "onboarding-scopes": "static-1.6590",
  "onboarding-tours-client": "static-1.5063",
  "platform-infra-nav-components": "static-1.7771",
  "subscription-experience-data-types": "static-1.15079",
  "crm-record-cards-service-types": "static-1.3682",
  "location-customization-utils-lib": "static-1.9629",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.6115",
  "signup-constants": "static-1.19175",
  "signup-ui-url-generator": "static-2.8188",
  "card-properties-lib": "static-1.44585",
  "commerce-subscription-lib": "static-1.37451",
  "crm-actions": "static-1.6469",
  "crm-cards-sdk": "static-1.43981",
  "customer-data-properties-shared-msw-handlers": "static-1.9613",
  "customer-data-tracking": "static-1.7016",
  "hs-resources": "static-1.307",
  "pulse": "static-1.734",
  "calling-global-api": "static-1.64945",
  "calling-internal-common": "static-1.31442",
  "calling-lifecycle-internal": "static-1.66327",
  "calling-lifecycle-messages": "static-1.58621",
  "commerce-products-lib": "static-1.10049",
  "conditional-properties-service-client": "static-1.3895",
  "crm-links": "static-1.6438",
  "crm-pipelines-api-client-types": "static-1.4234",
  "external-options-client-types": "static-1.4224",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4315",
  "meetings-icalendar-utils-lib": "static-1.763",
  "multi-currency-client-types": "static-1.3788",
  "object-builder-ui-client": "static-1.49195",
  "pipeline-validation-client-types": "static-1.4063",
  "smart-property-lib": "static-1.7916",
  "tiered-pricing": "static-1.1553",
  "ui-addon-form-validation": "static-1.11121",
  "zustand": "static-1.74",
  "fdsr-migration-layer": "static-1.143",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.1213",
  "growth-data-modal": "static-1.5643",
  "growth-onboarding-confetti": "static-1.3196",
  "growth-onboarding-next-action-utils": "static-1.2290",
  "onboarding-tours-utils": "static-1.915",
  "ui-shepherd-tracker": "static-1.7764",
  "academy-service-client": "static-1.3814",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39484",
  "FileManagerLib": "static-1.39625",
  "SafeStorage": "static-1.4530",
  "video-embed": "static-1.36196",
  "ui-coaching-tips": "static-1.28920",
  "redux-actions": "static-3.7",
  "EmailSignatureEditor": "static-1.24657",
  "viral-links-lib": "static-1.7200",
  "data-token-picker": "static-1.16637",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.368",
  "timezone-utils": "static-2.5373",
  "seat-types-lib": "static-1.305",
  "getting-started-shared-tasks-store": "static-1.17893",
  "ui-addon-opt": "static-4.8492",
  "campaign-roi-lib": "static-1.9483",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-views-management": "static-1.25710",
  "framework-data-table": "static-2.12206",
  "marketing-platform-lib": "static-1.6996",
  "nudge-client-utils": "static-1.2861",
  "nudge-custom-ui-functions": "static-1.1259",
  "switchboard-lib": "static-1.355",
  "app-users-service-client": "static-1.5742",
  "app-users-service-types": "static-1.5150",
  "mini-checkout-client": "static-1.27117",
  "onboarding-utils": "static-1.5488",
  "permissions-shared-i18n-strings-fe": "static-1.2062",
  "ui-coaching-tips-shared-config": "static-1.28905",
  "content-media-composition-data-lib": "static-1.12718",
  "fix-webm-duration": "static-1.24",
  "notification-sounds": "static-1.4556",
  "commerce-tours-lib": "static-1.6342",
  "growth-onboarding-reliability": "static-1.5211",
  "sales-checkout-service-client": "static-1.3722",
  "content-media-compositions": "static-2.16725",
  "media-bridge-lib": "static-1.19151",
  "edison-service-client-types": "static-1.518",
  "crm_data": "static-4.92376",
  "customer-data-sidebar": "static-2.46371",
  "enrichment-properties-lib": "static-1.17034",
  "ui-addon-draggable-compat": "static-2.4390",
  "universal-record-utils-lib": "static-1.1293",
  "commerce-billing-lib": "static-1.19515",
  "commerce-shared-components-lib": "static-1.18862",
  "commerce-tools-ui-lib": "static-1.10719",
  "crm-fe-perf": "static-1.23031",
  "event-emitter": "static-1.1080",
  "bend-plugin-pulse": "static-1.237",
  "fast-json-patch": "static-1.64",
  "calling-error-reporting": "static-1.31449",
  "shared-worker-versioning": "static-1.11165",
  "calling-usage-tracker": "static-1.6674",
  "voice-sms-access-library": "static-1.1480",
  "commerce-permissions": "static-1.906",
  "products-iframe-lib": "static-1.8287",
  "products-ui-components-shared-msw-handlers": "static-1.10668",
  "data-agent-kit": "static-1.411",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10369",
  "policy-lib": "static-1.6916",
  "react-tinymce": "static-1.55586",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10432",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54712",
  "tinymce-plugins": "static-1.57826",
  "tinymce-themes": "static-1.56682",
  "onboarding-data-sync-lib": "static-1.2192",
  "growth-onboarding-next-action-components": "static-1.2318",
  "user-context-client": "static-1.4709",
  "audio-components": "static-1.6117",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.37136",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4665",
  "video-components": "static-1.13706",
  "outpost": "static-1.4299",
  "growth-onboarding-feedback-components": "static-1.6709",
  "draft-convert": "static-2.74",
  "draft-extend": "static-3.76",
  "draft-js": "static-5.79",
  "draft-plugins": "static-2.21904",
  "sales-email-signature-service-client": "static-1.3980",
  "ts-utils-lib": "static-1.304",
  "crm-export-dialog": "static-1.6415",
  "crm-index-associations-lib": "static-1.6571",
  "crm-view-components": "static-1.665",
  "react-beautiful-dnd": "static-1.13",
  "customer-data-associations": "static-1.7462",
  "nudge-custom-function-registry": "static-1.2618",
  "nudge-renderer-utils": "static-1.2937",
  "whisper-core-api": "static-1.6906",
  "InboxConnectUtils": "static-4.15158",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5828",
  "settings-content-modals": "static-1.46450",
  "js-cookie": "static-1.18",
  "crm_universal": "static-1.22238",
  "customer-data-email": "static-1.18265",
  "card-payment-highlight-lib": "static-1.37544",
  "card-subscription-highlight-lib": "static-1.39874",
  "commerce-contract-lib": "static-1.12674",
  "invoices-highlight-card-lib": "static-1.55149",
  "orders-highlight-card-lib": "static-1.21822",
  "products-highlight-card-lib": "static-1.18332",
  "quotes-highlight-card-lib": "static-1.72453",
  "crm-source-interpretation-lib": "static-1.5461",
  "crm-object-search-query-utilities": "static-1.9869",
  "utility-belt": "static-1.2662",
  "payments-enrollment-embed-lib": "static-1.23303",
  "stripe-embedded-components": "static-1.7739",
  "customer-data-rte": "static-1.33330",
  "cv-backend-services": "static-1.1571",
  "growth-onboarding-empty-states": "static-1.5983",
  "payments-post-enroll-local-storage-lib": "static-1.5236",
  "qrcode-generator": "static-1.70",
  "quotes-client-types": "static-1.38543",
  "trials-service-types": "static-1.4013",
  "calling-orchestration-schema": "static-1.36257",
  "sales-views-client-types": "static-1.4387",
  "hub-http-contrib": "static-1.3173",
  "interframe": "static-3.4889",
  "tinymce-data": "static-1.40797",
  "ui-addon-sales-email": "static-1.5340",
  "layout-dnd-components": "static-1.12699",
  "layout-dnd-utils": "static-1.11674",
  "ui-brand-identity-lib": "static-1.15742",
  "NamespacedHubStyle": "static-2.9151",
  "meetings-connect-utils-lib": "static-1.7735",
  "social-insights-client-types": "static-1.22388",
  "crm-index-visualization-core": "static-1.4304",
  "checkout-sdk": "static-3.23960",
  "company-details-components": "static-1.6327",
  "payment-method-components": "static-1.6999",
  "pricing-pages-ui-components": "static-1.14775",
  "quote-checkout-service-types": "static-1.3595",
  "upgrade-catalog-service-types": "static-1.3651",
  "access-control-lib": "static-1.10567",
  "EmailComponents": "static-1.55134",
  "EmailData": "static-1.53811",
  "redux-less": "static-2.9612",
  "sequences-lib": "static-1.8260",
  "ui-gdpr-components": "static-1.10481",
  "products-ui-components": "static-1.40567",
  "accounting-integrations-ui-components": "static-1.7277",
  "invoices-ui-lib": "static-1.55165",
  "commerce-products-api": "static-1.2483",
  "invoices-iframe-lib": "static-1.57223",
  "quotes-modal-lib": "static-1.103131",
  "quotes-ui-lib": "static-1.81174",
  "stripe-connect-js": "static-1.71",
  "draft-content-plugins": "static-1.28596",
  "ContentData": "static-1.68819",
  "layout-data-lib": "static-1.9999",
  "checkout-service-types": "static-1.3894",
  "hub-http-rxjs": "static-1.814",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.4067",
  "billing-payments-client-types": "static-1.4120",
  "react-performance-metrics-lib": "static-1.687",
  "pricing-pages-api": "static-1.14640",
  "ContentComponents": "static-2.71700",
  "marketing-contacts-lib": "static-1.10468",
  "marketing-email-service-types": "static-1.2000",
  "messaging-editing-lib": "static-1.46653",
  "messaging-usage-based-billing-components-lib": "static-1.1515",
  "automation-ui-source-apps": "static-1.19260",
  "automation-ui-types": "static-1.20178",
  "messaging-types-lib": "static-1.46390",
  "onboarding-settings-client": "static-1.4635",
  "sequences-client-types-lib": "static-1.8117",
  "commerce-tax-lib": "static-1.666",
  "price-books-api": "static-1.1281",
  "price-books-components": "static-1.1339",
  "property-description-translator": "static-1.3971",
  "ramp-editor": "static-1.487",
  "commerce-analytics-service-client": "static-1.3710",
  "totals-ui-components": "static-1.23947",
  "SalesContentIndexUI": "static-3.9426",
  "advanced-menus-core": "static-1.15344",
  "advanced-menus-lib": "static-1.12255",
  "ui-memberships-settings-lib": "static-1.34392",
  "segments-query-core": "static-1.1550",
  "automation-ui-ubb": "static-1.6094",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7468",
  "data-token-views": "static-1.16618",
  "forms-utils-lib": "static-1.12827",
  "payments-embed-points-lib": "static-1.13302",
  "simple-menus-core": "static-1.15343",
  "simple-menus-lib": "static-1.16860",
  "videoconference-integration-components": "static-1.7020",
  "mc-hard-limits-client-types": "static-1.29",
  "marketing-contacts-client": "static-1.7641",
  "automation-applications-service-types": "static-1.3594",
  "automation-platform-service-types": "static-1.2632",
  "ContentEditorUI": "static-2.77468",
  "short-messages-app-service-client": "static-1.4052",
  "web-interactives-components": "static-1.13988",
  "web-interactives-data": "static-1.13989",
  "messaging-shared-utils-lib": "static-1.964",
  "messaging-user-info-utils-lib": "static-1.1134",
  "email-portal-health-service-types": "static-1.1107",
  "line-items-api": "static-1.881",
  "commerce-totals-service-types": "static-1.3915",
  "FireAlarmUi": "static-1.4605",
  "sales-templates-service-types-lib": "static-1.4266",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22114",
  "automation-ui-usage-tracking": "static-1.21577",
  "data-studio-ubb": "static-1.3098",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27316",
  "collaboration-sidebar": "static-1.58231",
  "content-management-data-lib": "static-1.5642",
  "copilot-plugins": "static-1.11439",
  "cta-picker": "static-1.36736",
  "customer-agent-discovery-components-lib": "static-1.3454",
  "editor-components": "static-1.13420",
  "editor-iframe-lib": "static-1.8585",
  "error-messaging-js": "static-1.5324",
  "FormsCommonComponents": "static-1.86168",
  "pictos": "static-7.186",
  "react-transition-group": "static-2.66",
  "redux-request-state": "static-1.10776",
  "SharedLegalStrings": "static-1.1875",
  "smart-content-core": "static-1.42796",
  "smart-content-lib": "static-1.43449",
  "social-composer-lib": "static-1.59613",
  "structured-content-lib": "static-1.25536",
  "theme-previewer-lib": "static-1.53596",
  "tinymce-copilot": "static-1.16780",
  "xray-recommendation-lib": "static-1.8073",
  "automation-ui-routing": "static-1.21535",
  "sql-reporting-client-types": "static-1.5745",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42476",
  "campaigns-utils-lib": "static-1.3324",
  "reporting-enablement": "static-1.23360",
  "chatspot-widget-iframe": "static-1.21902",
  "collaboration-sidebar-common": "static-1.3028",
  "forms-ai-lib": "static-1.4523",
  "codemirror-dlb": "static-1.59027",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6565",
  "report-customization-components": "static-1.13520",
  "data-quality-ui-library": "static-1.13375",
  "reporting-filters": "static-1.643",
  "reporting-insights-lib": "static-1.2126"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12768",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.484",
  "data-fetching-client": "/data-fetching-client/static-1.9791",
  "foundations-components": "/foundations-components/static-1.8191",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1216",
  "foundations-theming": "/foundations-theming/static-1.4562",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.83",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8150",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10286",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11600",
  "I18n": "/I18n/static-7.1641",
  "jasmine-runner": "/jasmine-runner/static-1.6587",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12831",
  "quartz": "/quartz/static-1.7202",
  "react-dlb": "/react-dlb/static-1.81",
  "react-rhumb": "/react-rhumb/static-1.16814",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2987",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10016",
  "settings-ui-lib": "/settings-ui-lib/static-1.12652",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7374",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11279",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9666",
  "unified-auth": "/unified-auth/static-1.649",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.931",
  "usage-tracker": "/usage-tracker/static-1.7481",
  "usage-tracker-core": "/usage-tracker-core/static-1.7331",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8225",
  "hub-http": "/hub-http/static-1.6352",
  "integrations-lib": "/integrations-lib/static-1.16565",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20197",
  "property-management-iframe": "/property-management-iframe/static-1.13596",
  "quartz-config": "/quartz-config/static-1.980",
  "quartz-core": "/quartz-core/static-1.6421",
  "quartz-routing": "/quartz-routing/static-1.632",
  "quick-fetch": "/quick-fetch/static-1.4015",
  "react": "/react/static-7.187",
  "rpc-client-utils": "/rpc-client-utils/static-1.4787",
  "ts-schema": "/ts-schema/static-1.4179",
  "ui-universal-auth": "/ui-universal-auth/static-1.9135",
  "UIComponents": "/UIComponents/static-3.8546",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3497",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3479",
  "quartz-webpack": "/quartz-webpack/static-1.3426",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.280",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4460",
  "floating-ui": "/floating-ui/static-1.58",
  "foundations-assets": "/foundations-assets/static-1.5004",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2278",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-story-utils": "/hs-story-utils/static-1.9553",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.39",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5439",
  "react-virtualized": "/react-virtualized/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2215",
  "ui-fonts": "/ui-fonts/static-1.862",
  "ui-images": "/ui-images/static-2.1188",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3045",
  "foundations-theming-base": "/foundations-theming-base/static-1.3547",
  "stylex": "/stylex/static-1.35",
  "HeadJS": "/HeadJS/static-2.773",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3261",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4455",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9280",
  "ai-rendering-library": "/ai-rendering-library/static-1.10647",
  "chirp-fetch": "/chirp-fetch/static-1.2018",
  "connections-embed-lib": "/connections-embed-lib/static-1.1239",
  "copilot-toolkit": "/copilot-toolkit/static-1.11466",
  "feedback-loader": "/feedback-loader/static-1.29538",
  "laboratory-lib": "/laboratory-lib/static-3.7282",
  "marketplace-embed": "/marketplace-embed/static-1.22492",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10092",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20152",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14367",
  "sanitize-text": "/sanitize-text/static-1.8277",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8835",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5895",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5167",
  "wootric-nps": "/wootric-nps/static-1.7080",
  "quartz-head": "/quartz-head/static-1.867",
  "web-vitals": "/web-vitals/static-1.7",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4781",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4280",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2578",
  "reporting-data": "/reporting-data/static-1.68083",
  "cssUtils": "/cssUtils/static-1.830",
  "flux-actions": "/flux-actions/static-1.348",
  "HubStyle": "/HubStyle/static-2.11907",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10337",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10492",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7471",
  "icons": "/icons/static-2.656",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18729",
  "storybook-react": "/storybook-react/static-1.34",
  "trellis-story-utils": "/trellis-story-utils/static-1.4640",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5674",
  "quartz-i18n": "/quartz-i18n/static-1.877",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.55",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.460",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.620",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.768",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.76",
  "slack-ui-library": "/slack-ui-library/static-1.10527",
  "fsm": "/fsm/static-1.3861",
  "customer-data-objects": "/customer-data-objects/static-1.7809",
  "property-translator": "/property-translator/static-1.5527",
  "hs-locale-management": "/hs-locale-management/static-1.178",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8056",
  "hs-promise-utils": "/hs-promise-utils/static-1.5723",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5008",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13980",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5737",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7911",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4607",
  "superstore": "/superstore/static-1.4890",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10383",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8095",
  "hub-http-janus": "/hub-http-janus/static-1.848",
  "hubspotter-http": "/hubspotter-http/static-1.4748",
  "immutable-less": "/immutable-less/static-1.4782",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17604",
  "nav-meta": "/nav-meta/static-1.29956",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18171",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3943",
  "property-management-common": "/property-management-common/static-1.5884",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9197",
  "dispatcher": "/dispatcher/static-1.139",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.547",
  "module-federation": "/module-federation/static-1.27",
  "quartz-auth": "/quartz-auth/static-1.877",
  "quartz-test": "/quartz-test/static-1.877",
  "quartz-tracking": "/quartz-tracking/static-1.581",
  "trellis-components": "/trellis-components/static-1.2234",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.197",
  "bender-build-tools": "/bender-build-tools/static-1.3301",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21911",
  "ContentUtils": "/ContentUtils/static-1.68744",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13159",
  "sassPrefix": "/sassPrefix/static-1.158",
  "avatar-components": "/avatar-components/static-1.2628",
  "breeze-engine-core": "/breeze-engine-core/static-1.443",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.288",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40250",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13305",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14777",
  "ExportDialog": "/ExportDialog/static-6.10510",
  "highlight.js": "/highlight.js/static-1.80",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41628",
  "reporting-snowflake": "/reporting-snowflake/static-1.56701",
  "reporting-ui-components": "/reporting-ui-components/static-2.65354",
  "reporting-visualizations": "/reporting-visualizations/static-1.60159",
  "trellis-theming": "/trellis-theming/static-1.1073",
  "ui-addon-teams": "/ui-addon-teams/static-1.21719",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.212",
  "magpie-lib": "/magpie-lib/static-1.5640",
  "navigation-components": "/navigation-components/static-1.18319",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1165",
  "magpie-types": "/magpie-types/static-1.5100",
  "simple-logging-lib": "/simple-logging-lib/static-1.3179",
  "ai-studio-lib": "/ai-studio-lib/static-1.11998",
  "app-governance-lib": "/app-governance-lib/static-1.1963",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10654",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18601",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8139",
  "ui-product-approvals": "/ui-product-approvals/static-1.28662",
  "ui-tool-access": "/ui-tool-access/static-1.10280",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9484",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5898",
  "usage-tracker-public": "/usage-tracker-public/static-1.7292",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3684",
  "persist-promise": "/persist-promise/static-1.3831",
  "reference-resolvers": "/reference-resolvers/static-1.8306",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4054",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.467",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3141",
  "final-form": "/final-form/static-1.71",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.3142",
  "atom": "/atom/static-1.5206",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6112",
  "salesImages": "/salesImages/static-1.527",
  "batch-promise": "/batch-promise/static-1.1674",
  "crm-component-utils": "/crm-component-utils/static-1.39422",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6020",
  "customer-data-properties": "/customer-data-properties/static-1.52004",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7024",
  "property-value-citations": "/property-value-citations/static-1.2618",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8226",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9197",
  "navigation-messaging": "/navigation-messaging/static-1.7646",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10284",
  "base-ui": "/base-ui/static-1.15",
  "react-day-picker": "/react-day-picker/static-1.4",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "cms-field-types": "/cms-field-types/static-1.4945",
  "content-icons-ui": "/content-icons-ui/static-1.2264",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9955",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7377",
  "crm-message-bus": "/crm-message-bus/static-1.43328",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22685",
  "events-data-lib": "/events-data-lib/static-1.364",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4852",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4102",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6929",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1112",
  "onboarding-tours": "/onboarding-tours/static-1.16849",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14054",
  "academy-common-lib": "/academy-common-lib/static-1.14237",
  "content-assistance-lib": "/content-assistance-lib/static-1.7961",
  "dashboard-lib": "/dashboard-lib/static-1.82032",
  "file-manager-components": "/file-manager-components/static-1.23985",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18775",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18593",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20056",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8833",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4890",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11203",
  "user-context": "/user-context/static-1.5238",
  "growth-payments-core": "/growth-payments-core/static-1.25760",
  "reporting-plugins": "/reporting-plugins/static-1.10524",
  "reporting-reports": "/reporting-reports/static-1.67761",
  "idb-keyval": "/idb-keyval/static-1.45",
  "reactive-lib": "/reactive-lib/static-1.856",
  "nest": "/nest/static-1.362",
  "ably": "/ably/static-2.2",
  "codemirror": "/codemirror/static-5.96",
  "react-codemirror": "/react-codemirror/static-1.10758",
  "framework-listing-lib": "/framework-listing-lib/static-2.29057",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31011",
  "apps-service-types": "/apps-service-types/static-1.3931",
  "oauth-service-types": "/oauth-service-types/static-1.4384",
  "content-media-capture": "/content-media-capture/static-1.4914",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8559",
  "payment-link-components": "/payment-link-components/static-1.23849",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10016",
  "video-components-external": "/video-components-external/static-1.11704",
  "video-data-lib": "/video-data-lib/static-1.35362",
  "react-dnd-compat": "/react-dnd-compat/static-1.4744",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.557",
  "onboarding-scopes": "/onboarding-scopes/static-1.6590",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5063",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7771",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15079",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3682",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9629",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.6115",
  "signup-constants": "/signup-constants/static-1.19175",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8188",
  "card-properties-lib": "/card-properties-lib/static-1.44585",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37451",
  "crm-actions": "/crm-actions/static-1.6469",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43981",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9613",
  "customer-data-tracking": "/customer-data-tracking/static-1.7016",
  "hs-resources": "/hs-resources/static-1.307",
  "pulse": "/pulse/static-1.734",
  "calling-global-api": "/calling-global-api/static-1.64945",
  "calling-internal-common": "/calling-internal-common/static-1.31442",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66327",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58621",
  "commerce-products-lib": "/commerce-products-lib/static-1.10049",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3895",
  "crm-links": "/crm-links/static-1.6438",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4234",
  "external-options-client-types": "/external-options-client-types/static-1.4224",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4315",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.763",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3788",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49195",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4063",
  "smart-property-lib": "/smart-property-lib/static-1.7916",
  "tiered-pricing": "/tiered-pricing/static-1.1553",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11121",
  "zustand": "/zustand/static-1.74",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.143",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1213",
  "growth-data-modal": "/growth-data-modal/static-1.5643",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3196",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2290",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.915",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7764",
  "academy-service-client": "/academy-service-client/static-1.3814",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39484",
  "FileManagerLib": "/FileManagerLib/static-1.39625",
  "SafeStorage": "/SafeStorage/static-1.4530",
  "video-embed": "/video-embed/static-1.36196",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28920",
  "redux-actions": "/redux-actions/static-3.7",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24657",
  "viral-links-lib": "/viral-links-lib/static-1.7200",
  "data-token-picker": "/data-token-picker/static-1.16637",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.368",
  "timezone-utils": "/timezone-utils/static-2.5373",
  "seat-types-lib": "/seat-types-lib/static-1.305",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17893",
  "ui-addon-opt": "/ui-addon-opt/static-4.8492",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9483",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-views-management": "/customer-data-views-management/static-1.25710",
  "framework-data-table": "/framework-data-table/static-2.12206",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6996",
  "nudge-client-utils": "/nudge-client-utils/static-1.2861",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1259",
  "switchboard-lib": "/switchboard-lib/static-1.355",
  "app-users-service-client": "/app-users-service-client/static-1.5742",
  "app-users-service-types": "/app-users-service-types/static-1.5150",
  "mini-checkout-client": "/mini-checkout-client/static-1.27117",
  "onboarding-utils": "/onboarding-utils/static-1.5488",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2062",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28905",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12718",
  "fix-webm-duration": "/fix-webm-duration/static-1.24",
  "notification-sounds": "/notification-sounds/static-1.4556",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6342",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5211",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3722",
  "content-media-compositions": "/content-media-compositions/static-2.16725",
  "media-bridge-lib": "/media-bridge-lib/static-1.19151",
  "edison-service-client-types": "/edison-service-client-types/static-1.518",
  "crm_data": "/crm_data/static-4.92376",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46371",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.17034",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4390",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1293",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19515",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18862",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10719",
  "crm-fe-perf": "/crm-fe-perf/static-1.23031",
  "event-emitter": "/event-emitter/static-1.1080",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.237",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "calling-error-reporting": "/calling-error-reporting/static-1.31449",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11165",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6674",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1480",
  "commerce-permissions": "/commerce-permissions/static-1.906",
  "products-iframe-lib": "/products-iframe-lib/static-1.8287",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10668",
  "data-agent-kit": "/data-agent-kit/static-1.411",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10369",
  "policy-lib": "/policy-lib/static-1.6916",
  "react-tinymce": "/react-tinymce/static-1.55586",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10432",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54712",
  "tinymce-plugins": "/tinymce-plugins/static-1.57826",
  "tinymce-themes": "/tinymce-themes/static-1.56682",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2192",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2318",
  "user-context-client": "/user-context-client/static-1.4709",
  "audio-components": "/audio-components/static-1.6117",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.37136",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4665",
  "video-components": "/video-components/static-1.13706",
  "outpost": "/outpost/static-1.4299",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6709",
  "draft-convert": "/draft-convert/static-2.74",
  "draft-extend": "/draft-extend/static-3.76",
  "draft-js": "/draft-js/static-5.79",
  "draft-plugins": "/draft-plugins/static-2.21904",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3980",
  "ts-utils-lib": "/ts-utils-lib/static-1.304",
  "crm-export-dialog": "/crm-export-dialog/static-1.6415",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6571",
  "crm-view-components": "/crm-view-components/static-1.665",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "customer-data-associations": "/customer-data-associations/static-1.7462",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2618",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2937",
  "whisper-core-api": "/whisper-core-api/static-1.6906",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15158",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5828",
  "settings-content-modals": "/settings-content-modals/static-1.46450",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_universal": "/crm_universal/static-1.22238",
  "customer-data-email": "/customer-data-email/static-1.18265",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37544",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39874",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12674",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55149",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21822",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18332",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72453",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5461",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9869",
  "utility-belt": "/utility-belt/static-1.2662",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23303",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7739",
  "customer-data-rte": "/customer-data-rte/static-1.33330",
  "cv-backend-services": "/cv-backend-services/static-1.1571",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5983",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5236",
  "qrcode-generator": "/qrcode-generator/static-1.70",
  "quotes-client-types": "/quotes-client-types/static-1.38543",
  "trials-service-types": "/trials-service-types/static-1.4013",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36257",
  "sales-views-client-types": "/sales-views-client-types/static-1.4387",
  "hub-http-contrib": "/hub-http-contrib/static-1.3173",
  "interframe": "/interframe/static-3.4889",
  "tinymce-data": "/tinymce-data/static-1.40797",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5340",
  "layout-dnd-components": "/layout-dnd-components/static-1.12699",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11674",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15742",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9151",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7735",
  "social-insights-client-types": "/social-insights-client-types/static-1.22388",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4304",
  "checkout-sdk": "/checkout-sdk/static-3.23960",
  "company-details-components": "/company-details-components/static-1.6327",
  "payment-method-components": "/payment-method-components/static-1.6999",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14775",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3595",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3651",
  "access-control-lib": "/access-control-lib/static-1.10567",
  "EmailComponents": "/EmailComponents/static-1.55134",
  "EmailData": "/EmailData/static-1.53811",
  "redux-less": "/redux-less/static-2.9612",
  "sequences-lib": "/sequences-lib/static-1.8260",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10481",
  "products-ui-components": "/products-ui-components/static-1.40567",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7277",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55165",
  "commerce-products-api": "/commerce-products-api/static-1.2483",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57223",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103131",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81174",
  "stripe-connect-js": "/stripe-connect-js/static-1.71",
  "draft-content-plugins": "/draft-content-plugins/static-1.28596",
  "ContentData": "/ContentData/static-1.68819",
  "layout-data-lib": "/layout-data-lib/static-1.9999",
  "checkout-service-types": "/checkout-service-types/static-1.3894",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.814",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.4067",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4120",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.687",
  "pricing-pages-api": "/pricing-pages-api/static-1.14640",
  "ContentComponents": "/ContentComponents/static-2.71700",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10468",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2000",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46653",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1515",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19260",
  "automation-ui-types": "/automation-ui-types/static-1.20178",
  "messaging-types-lib": "/messaging-types-lib/static-1.46390",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4635",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8117",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.666",
  "price-books-api": "/price-books-api/static-1.1281",
  "price-books-components": "/price-books-components/static-1.1339",
  "property-description-translator": "/property-description-translator/static-1.3971",
  "ramp-editor": "/ramp-editor/static-1.487",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3710",
  "totals-ui-components": "/totals-ui-components/static-1.23947",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9426",
  "advanced-menus-core": "/advanced-menus-core/static-1.15344",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12255",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34392",
  "segments-query-core": "/segments-query-core/static-1.1550",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6094",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7468",
  "data-token-views": "/data-token-views/static-1.16618",
  "forms-utils-lib": "/forms-utils-lib/static-1.12827",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13302",
  "simple-menus-core": "/simple-menus-core/static-1.15343",
  "simple-menus-lib": "/simple-menus-lib/static-1.16860",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7020",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.29",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7641",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3594",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2632",
  "ContentEditorUI": "/ContentEditorUI/static-2.77468",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4052",
  "web-interactives-components": "/web-interactives-components/static-1.13988",
  "web-interactives-data": "/web-interactives-data/static-1.13989",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.964",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1134",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1107",
  "line-items-api": "/line-items-api/static-1.881",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3915",
  "FireAlarmUi": "/FireAlarmUi/static-1.4605",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4266",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22114",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21577",
  "data-studio-ubb": "/data-studio-ubb/static-1.3098",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27316",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58231",
  "content-management-data-lib": "/content-management-data-lib/static-1.5642",
  "copilot-plugins": "/copilot-plugins/static-1.11439",
  "cta-picker": "/cta-picker/static-1.36736",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3454",
  "editor-components": "/editor-components/static-1.13420",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8585",
  "error-messaging-js": "/error-messaging-js/static-1.5324",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86168",
  "pictos": "/pictos/static-7.186",
  "react-transition-group": "/react-transition-group/static-2.66",
  "redux-request-state": "/redux-request-state/static-1.10776",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1875",
  "smart-content-core": "/smart-content-core/static-1.42796",
  "smart-content-lib": "/smart-content-lib/static-1.43449",
  "social-composer-lib": "/social-composer-lib/static-1.59613",
  "structured-content-lib": "/structured-content-lib/static-1.25536",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53596",
  "tinymce-copilot": "/tinymce-copilot/static-1.16780",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8073",
  "automation-ui-routing": "/automation-ui-routing/static-1.21535",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5745",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42476",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3324",
  "reporting-enablement": "/reporting-enablement/static-1.23360",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21902",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3028",
  "forms-ai-lib": "/forms-ai-lib/static-1.4523",
  "codemirror-dlb": "/codemirror-dlb/static-1.59027",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6565",
  "report-customization-components": "/report-customization-components/static-1.13520",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13375",
  "reporting-filters": "/reporting-filters/static-1.643",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2126"
}
};
